import Axios from "../services/axios.service";

export class ManagerService {
  static async automaticRouting(payload, password) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/transaction-management/add-automatic-routing`,
      data: payload,
      headers: { password: password },
    });
  }

  static async listRoutablePaycenters() {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/transaction-management/list-routable-paycenters`,
    });
  }

  static async confirmReceivedPayment(payload, password) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/transaction-management/confirm-received-payment`,
      data: payload,
      headers: { password: password },
    });
  }

  static async listRoutingConfig() {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/transaction-management/list-routing-config`,
    });
  }

  static async routePayableType(payload, password) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/transaction-management/route-payable-type`,
      data: payload,
      headers: { password: password },
    });
  }

  static async unlockTransaction(transactionId, imtoId) {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/transaction-management/unlocktransaction/${transactionId}?originating-imto-id=${imtoId}`,
    });
  }

  // static async getFontsFromGoogle(transactionId, imtoId) {
  //   return Axios({
  //     method: "GET",
  //     url: `web-services/api/v6/services/admin/transaction-management/unlocktransaction/${transactionId}/originating-imto-id=${imtoId}`,
  //   });
  // }
  static async fetchMobileDomainBrandIdentity() {
    return Axios({
      method: "GET",
      url: `/web-services/api/v6/services/generalmanagement/load-mobile-domain-brand-identity`,
    });
  }

  static async setUpEmailServer(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/organisation-settings/mail-setting`,
      data: payload,
    });
  }

  static async setUpTestEmailServer(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/organisation-settings/mail-setting-test`,
      data: payload,
    });
  }

  static async setUpAdditionalEmailGroup(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/organisation-settings/email-group-setup`,
      data: payload,
    });
  }

  static async setUpHideView(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/organisation-settings/ui-setting`,
      data: payload,
    });
  }

  static async getHideViewValues() {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/organisation-settings/get-ui-setting`,
    });
  }

  static async listApiTypes() {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/connector-management/list-api-plugin-connection`,
    });
  }

  static async listApiProviders(apiType) {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/connector-management/list-api-plugin?apiType=${apiType}`,
    });
  }

  static async setUpApiConnection(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/connector-management/create-api-connection`,
      data: payload,
    });
  }

  static async listApiIntegrations() {
    return Axios({
      method: "GET",
      url: `https://stag.moneytransferapplication.uk/web-services/api/v6/services/admin/connector-management/list-api-integration?page=1&size=10&apiType=AIRTIME_TOPUP&apiType=AGGREGATOR_SMS&apiType=AGGREGATOR_AIRTIME_TOPUP&apiType=AGGREGATOR_BILL_PAYMENTS&apiType=SOCIAL_LOGIN&apiType=SECURITY&apiType=ACTIVE_DIRECTORY&apiType=ADDRESS_LOOKUP&apiType=MONEY_TRANSFER&apiType=MONEY_TRANSFER_PAY_IN&apiType=CRYPTO_CURRENCY&apiType=MOBILE_MONEY_TRANSFER&apiType=BILL_PAYMENTS&apiType=ONLINE_PAYMENT&apiType=CUSTOM_POINT_OF_SALE_PAYMENT&apiType=ONLINE_BANK_PAYMENT&apiType=CRYPTO_CURRENCY_PAYMENT&apiType=PAYMENT_POINT&apiType=CURRENCY_EXCHANGE_RATE_FEED_API&apiType=IBAN_VALIDATOR&apiType=SWIFT_CODE_VALIDATOR&apiType=EXTERNAL_KYC_PROVIDER&apiType=TRANSACTION_MONITORING&apiType=CORRESPONDENT_BANK_ACCOUNT_CREATION&apiType=CORRESPONDENT_BANK_UTIL&apiType=WALLET_SYNCHRONIZATION&apiType=WALLET_ME&apiType=EXTERNAL_LEDGER_SYNCHRONIZATION&apiType=THIRD_PARTY_CARD_ISSUER`,
    });
  }

  static async deactivateAndActivateApiIntegrations(apiId) {
    return Axios({
      method: "PUT",
      url: `web-services/api/v6/services/admin/connector-management/activate-and-deactivate/${apiId}`,
    });
  }

  static async deleteApiIntegrations(apiId) {
    return Axios({
      method: "DELETE",
      url: `web-services/api/v6/services/admin/connector-management/delete-api-integration/${apiId}`,
    });
  }

  static async deleteRoute(routeId) {
    return Axios({
      method: "DELETE",
      url: `web-services/api/v6/services/admin/transaction-management/delete-routing/${routeId}`,
    });
  }

  static async changeRouteStatus(routeId) {
    return Axios({
      method: "PUT",
      url: `web-services/api/v6/services/admin/transaction-management/change-routing-status/${routeId}`,
    });
  }

  static async updateBrandSettings(payload) {
    return Axios({
      method: "PUT",
      url: `web-services/api/v6/services/admin/organisation-preference-management/update-organisaction-brand`,
      data: payload,
    });
  }

  static async updateMobileAppSettings(payload) {
    return Axios({
      method: "PUT",
      url: `web-services/api/v6/services/admin/organisation-preference-management/update-mobile-organisaction-brand`,
      data: payload,
    });
  }

  static async addExternalPayCenter(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/pay-centre-management/add-external-pay-centre`,
      data: payload,
    });
  }
}
